import React from "react";
import T from "prop-types";
import { Link } from "react-router-dom";
import { renderIf } from "MODULES/shared/decorators/index";
import { Detail, DetailTable, Section } from "MODULES/shared/components/index";
import { shortDate } from "LIB/formatters/date";

function RepairDetails({ rma }) {
  const repairItem = rma.repair_order_line_item;
  return (
    <React.Fragment>
      <hr className="hr-xs hr-dashed" />
      <Section title="RO #" editable={false}>
        <DetailTable>
          <Detail
            label="Code"
            value={
              <Link to={`/repair-orders/${repairItem.uuid}`}>
                {repairItem.code}
              </Link>
            }
          />
          <Detail
            label="RO Date Out"
            value={shortDate(repairItem.created_at)}
          />
          <Detail
            label="RO Date In"
            value={shortDate(repairItem.date_received)}
          />
          <Detail
            label="Returning AWB #"
            value={repairItem.incoming_awb_number}
          />
        </DetailTable>
      </Section>
    </React.Fragment>
  );
}

RepairDetails.propTypes = {
  rma: T.shape({
    repair_order_line_item: T.shape({})
  })
};

export default renderIf(({ rma }) => !!rma.repair_order_line_item)(
  RepairDetails
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/RepairDetails/RepairDetails.jsx